<template>
  <CCol sm="12" class="px-0">
    <CRow>
      <CCol sm="8" class="form-group search-div form-mar-grp mb-0">
        <div class="d-flex align-center">
          <label for="" class="mr-4 mt-1 mb-0"
            >DocSmart commission for {{ docsmartCommision.feature }}
          </label>
          <v-switch
            hide-details
            class="mt-0"
            v-model="docsmartCommision.is_enabled"
          ></v-switch>
        </div>
      </CCol>
    </CRow>
    <CRow v-if="docsmartCommision.is_enabled">
      <v-radio-group v-model="docsmartCommision.type">
        <v-radio label="Percentage" value="percentage"></v-radio>
        <v-radio label="Fixed amount" value="flat_amount"></v-radio>
        <v-radio label="Percentage or fixed amount" value="both"></v-radio>
      </v-radio-group>
      <CCol
        sm="3"
        class="form-group search-div form-mar-grp mb-0"
        v-if="docsmartCommision.type === 'percentage'"
      >
        <input
          type="number"
          class="form-control mt-4"
          placeholder="Percentage"
          v-model="docsmartCommision.percentage"
        />
      </CCol>
      <CCol
        sm="3"
        class="form-group search-div form-mar-grp mb-0"
        v-if="docsmartCommision.type === 'flat_amount'"
      >
        <input
          type="number"
          class="form-control mt-4"
          placeholder="Fixed amount"
          v-model="docsmartCommision.flat_amount"
        />
      </CCol>
      <CCol
        sm="6"
        class="form-group search-div form-mar-grp mb-0"
        v-if="docsmartCommision.type === 'both'"
      >
        <div class="mt-4 d-flex align-center">
          <input
            type="number"
            class="form-control mr-4"
            placeholder="Percentage"
            v-model="docsmartCommision.percentage"
          />
          <input
            type="number"
            class="form-control"
            placeholder="Fixed amount"
            v-model="docsmartCommision.flat_amount"
          />
        </div>
        <p class="mb-0 mt-1">
          <b>Note :</b> Percentage or fixed amount whichever is small will be
          used as commision fees
        </p>
      </CCol>
    </CRow>
  </CCol>
</template>
<script>
export default {
  props: ["docsmartCommision", "index"],
  watch: {
    docsmartCommision: {
      deep: true,
      handler(newValue) {
        this.$emit("save", newValue, this.index);
      },
    },
  },
};
</script>
